import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useLocation, useNavigate } from 'react-router-dom'
import qs from 'query-string'

// store
import { useAppDispatch, useAppSelector } from 'src/store'

// enums
import { USER_STATE } from 'src/enum/userStatus'
import { USER_TREATMENT_STATE } from 'src/enum/userTreatmentState'

// components
import CommonModal from 'src/components/Modal/CommonModal'
import LPHeader from 'src/components/layout/Header/LPHeader'
import VideoCallModal from 'src/components/Modal/VideoCallModal'
import CancelTreatmentSection from 'src/components/common/CancelTreatmentSection'

// use case
import { handleRedirectByState } from 'src/useCase/keepFlow'
import {
  getUserTreatmentList,
  updateCallState,
} from 'src/useCase/userTreatment'

// images
import newRight from 'src/assets/icons/new-right.svg'
import { PATH as OTHER_MENU_PATH } from 'src/pages/myPage/OtherMenu'
import setUserTreatmentIdAction from 'src/store/domain/selectedUserTreatmentId/userTreatmentId'
import detailUserTreatmentAction from 'src/store/domain/myPage/detailUserTreatment'
import LocalStorage from 'src/utils/LocalStorage'

export type paramsType = {
  with: string
  not_state?: string
  has_request_call?: boolean
}
const Container: React.FC = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const urlParams = qs.parse(location.search)
  const user = useAppSelector((state) => state.ui.app.authInfo)
  const userTreatments = useAppSelector(
    (state) => state.domain.myPage.userTreatment.entities,
  )
  const selectedUserTreatmentId = useAppSelector(
    (state) =>
      state.domain.selectedUserTreatmentId.userTreatmentId
        .selectedUserTreatmentId,
  )

  const [openModal, setOpenModal] = useState(false)
  const [treatmentState, setTreatmentState] = useState('')
  const [isVideoCallModal, setIsVideoCallModal] = useState(false)
  const [doctorRequestDate, setDoctorRequestDate] = useState<
    string | undefined
  >('')
  const [menuName, setMenuName] = useState('')
  const [isCancelRequestedModalOpen, setIsCancelRequestedModalOpen] =
    useState(false)

  const getUserTreatments = () => {
    const notState = [
      USER_TREATMENT_STATE.DOCTOR_PRESCRIPTION_OK,
      USER_TREATMENT_STATE.SUBSCRIPTION_CONTRACT,
      USER_TREATMENT_STATE.CANCELED,
      USER_TREATMENT_STATE.DOCTOR_CANCEL_PRESCRIPTION,
    ]

    let params: paramsType = {
      with: 'menu,reservations,lastDoctorFeedback,lastOrder.plan,userTreatmentTransitions,userTreatments,userTreatments.reservations',
      not_state: notState.join(','),
      has_request_call: true,
    }

    if (urlParams.from === 'chat') {
      params = {
        ...params,
        not_state: [
          USER_TREATMENT_STATE.CANCELED,
          USER_TREATMENT_STATE.DOCTOR_CANCEL_PRESCRIPTION,
        ].join(','),
        has_request_call: false,
      }
    }

    dispatch(getUserTreatmentList(params))
  }

  const handleConfirm = () => {
    setIsVideoCallModal(false)
    if (selectedUserTreatmentId) {
      dispatch(
        updateCallState({ id: selectedUserTreatmentId, state: 'accepted' }),
      )
    }
    return navigate(OTHER_MENU_PATH)
  }

  const handleDecline = async () => {
    setIsVideoCallModal(false)
    if (selectedUserTreatmentId) {
      dispatch(
        updateCallState({ id: selectedUserTreatmentId, state: 'rejected' }),
      )
    }
    getUserTreatments()
  }

  useEffect(() => {
    LocalStorage.removeVideoSchedule()
    getUserTreatments()
  }, [location.search])

  return (
    <Wrapper>
      <LPHeader />
      <div className="other-menu">
        <div className="w-full justify-center mt-20 mx-auto layout-webview">
          {userTreatments &&
            userTreatments.map((userTreatment, index) => {
              return (
                <div
                  key={index}
                  onClick={() => {
                    dispatch(
                      setUserTreatmentIdAction.setSelectedUserTreatmentId(
                        userTreatment.id,
                      ),
                    )

                    dispatch(
                      detailUserTreatmentAction.updateEntity(userTreatment),
                    )

                    if (userTreatment.have_call_request_from_doctor) {
                      setIsVideoCallModal(true)
                      setDoctorRequestDate(userTreatment.doctor_request_date)
                      setMenuName(
                        userTreatment?.menu?.name ||
                          userTreatment.last_order?.plan?.name,
                      )
                      return
                    }

                    if (
                      userTreatment.state ===
                      USER_TREATMENT_STATE.CANCEL_REQUESTED
                    ) {
                      setIsCancelRequestedModalOpen(true)
                      return
                    }

                    const link = handleRedirectByState(
                      userTreatment,
                      user,
                      urlParams,
                    )

                    if (link === 'popup') {
                      setTreatmentState(
                        userTreatment.feedback_type || userTreatment.state,
                      )
                      return setOpenModal(true)
                    }

                    navigate(link)
                  }}
                  className="menu-item cursor-pointer"
                >
                  <span className="d-flex justify-content-between pb-10">
                    <div className="flex-auto flex fw-bold">
                      <span className="menu-name cl-black">
                        {userTreatment?.menu?.name ||
                          userTreatment.last_order?.plan?.name}
                      </span>
                    </div>
                    <div className="d-flex justify-content-end align-items-center">
                      <img
                        style={{ width: '15px', height: '20px' }}
                        src={newRight}
                      />
                    </div>
                  </span>
                </div>
              )
            })}
        </div>
        {!userTreatments.length && (
          <div className="d-flex justify-center mt-80">
            <div className="d-flex justify-center mx-auto">
              <p>契約している診療項目がありません。</p>
            </div>
          </div>
        )}
        {urlParams.from !== 'chat' && userTreatments.length > 0 && (
          <CancelTreatmentSection onCancelSuccess={getUserTreatments} />
        )}
      </div>

      <VideoCallModal
        isOpen={isVideoCallModal}
        onSubmit={handleConfirm}
        onCancel={handleDecline}
        doctorRequestDate={doctorRequestDate || ''}
        menuName={menuName}
      />

      <CommonModal
        isOpen={isCancelRequestedModalOpen}
        onClose={() => setIsCancelRequestedModalOpen(false)}
      >
        <div className="p-15 text-center mt-20">
          <p>
            この度はキャンセルのお申し込みをいただき、誠にありがとうございます。
          </p>
          <p>
            現在、順次キャンセル手続きを進めております。
            <br />
            手続きの完了までに1〜3営業日ほどお時間をいただく場合がございますので、あらかじめご了承ください。
          </p>
          <p>
            手続きが完了いたしましたら、改めてメールにてご連絡いたします。
            <br />
            今しばらくお待ちいただけますよう、何卒よろしくお願い申し上げます。
          </p>
        </div>
      </CommonModal>

      <CommonModal isOpen={openModal} onClose={() => setOpenModal(false)}>
        <div className="p-15 text-center mt-20">
          {treatmentState === USER_TREATMENT_STATE.CHOICE_INTERVIEW_METHOD ? (
            <>
              <b className="fs-20">医師の診察が必要です</b>
              <br />
              <br />
              <span className="text-center">
                問診の結果、お客様につきましては医師の診察が必要となります
              </span>
              <br />
              <span className="text-center">
                後ほど医師からご連絡をお待ちください。
              </span>
            </>
          ) : treatmentState ===
            USER_TREATMENT_STATE.DOCTOR_RESERVE_PRESCRIPTION ? (
            <>
              <b className="fs-20">医師の処方確認中です。</b>
            </>
          ) : user?.new_state === USER_STATE.IDENTIFICATION_OK ||
            treatmentState ===
              USER_TREATMENT_STATE.DOCTOR_PRESCRIPTION_CHECK ? (
            <>
              <b className="fs-20">医師の最終処方確認中です</b>
              <br />
              <br />
              <span className="text-center pt-25">
                本人確認書類が完了しましたので、医師によって処方の最終確認を行っております。
              </span>
              <br />
              <span className="text-center">しばらくお待ち下さい。</span>
            </>
          ) : (
            ''
          )}
        </div>
      </CommonModal>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: #f1efe7;
  min-height: 100vh;
  .other-menu {
    &__title {
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 24px;
      color: #000000;
      margin-top: 10px;
    }
    .menu-name {
      font-size: 15px;
      line-height: 32px;
    }
  }

  .menu-item {
    color: #000000;
    margin-bottom: 10px;
    border-bottom: 1px solid #d9d9d9;
    line-height: 40px;
  }

  .visibility-hidden {
    visibility: hidden;
  }

  .mt-80 {
    margin-top: 80px;
  }

  .btn-line {
    border: navajowhite;
    text-decoration: underline;
    cursor: pointer;
  }

  .text-title {
    font-weight: bold;
    margin: 20px;
  }

  .cursor-pointer {
    cursor: pointer;
  }
`

export default Container
